var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecipientWidgetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.919,
    height: 20,
    viewBox: "0 0 18.919 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13808",
    d: "M233.176 54.122a4.054 4.054 0 1 0 4.054 4.054 4.054 4.054 0 0 0-4.054-4.054zm-5.676 4.054a5.676 5.676 0 1 1 5.676 5.676 5.676 5.676 0 0 1-5.676-5.676z",
    transform: "translate(-223.716 -52.5)",
    style: {
      fill: "#333",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13809",
    d: "M147.5 271.149h15.593a7.838 7.838 0 0 0-15.592 0zm-1.663.811a9.46 9.46 0 0 1 18.919 0 .811.811 0 0 1-.811.811h-17.3a.811.811 0 0 1-.81-.811z",
    transform: "translate(-145.835 -252.77)",
    style: {
      fill: "#333",
      fillRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipientWidgetIcon);
export default __webpack_public_path__ + "static/media/recipient-widget-icon.4fe4d3f3d341ba1919ca6b0bfbae152e.svg";
export { ForwardRef as ReactComponent };